import { v1 as uuidV1 } from 'uuid';

export const generateAnonymousId = () => uuidV1();

const identify = (anonymousId, user) => {
  const falseyStringValues = ['undefined', 'null', 'unidentified'];
  const generateNewId = !anonymousId || falseyStringValues.includes(anonymousId);
  const id = generateNewId ? generateAnonymousId() : anonymousId;
  if (!id) {
    return { id: 'unidentified' };
  }

  return {
    id,
    userId: user.details ? user.details._id : null,
    anonymousId: id, // todo check if this should be reconciledId
    entitlements: user.entitlements || null,
    email: user.details ? user.details.email : null,
    identify: !anonymousId && !user.details,
    type: user.details ? 'logged_in' : 'anonymous',
    ...(user.countryCode && { isoCountryCode: user.countryCode }),
    isNewAnonymousId: generateNewId,
  };
};

export default identify;
